(function () {
  function addToCart(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: Number(variantId), quantity }),
    }).then(function (res) {
      if (!res.ok) throw new Error("Failed to add to cart");
      return res.json();
    });
  }

  function initBestSellers(section) {
    if (!section || section.dataset.bestSellersReady === "true") return;
    if (typeof Swiper === "undefined") return;

    section.dataset.bestSellersReady = "true";

    const tabs = section.querySelectorAll("[data-best-sellers-tab]");
    const panels = section.querySelectorAll("[data-best-sellers-panel]");
    const swipers = {};

    function needsSliderControls(swiper) {
      if (!swiper || swiper.params.enabled === false) return false;
      const slideCount = swiper.slides.length;
      const perView = Number(swiper.params.slidesPerView) || 1;
      return slideCount > perView;
    }

    function updateControls(swiper, panel) {
      const controls = panel.querySelector("[data-best-sellers-controls]");
      if (!controls) return;
      controls.hidden = !needsSliderControls(swiper);
    }

    function initCardGalleries(scope) {
      const root = scope || section;
      root.querySelectorAll("[data-card-gallery]").forEach(function (media) {
        const galleryEl = media.querySelector("[data-card-gallery-swiper]");
        const prevBtn = media.querySelector("[data-card-prev]");
        const nextBtn = media.querySelector("[data-card-next]");
        if (!galleryEl || galleryEl.swiper) return;

        new Swiper(galleryEl, {
          slidesPerView: 1,
          nested: true,
          allowTouchMove: true,
          speed: 300,
          navigation: {
            prevEl: prevBtn,
            nextEl: nextBtn,
          },
        });

        [prevBtn, nextBtn].forEach(function (btn) {
          if (!btn) return;
          btn.addEventListener("click", function (event) {
            event.stopPropagation();
          });
        });
      });
    }

    panels.forEach(function (panel) {
      const swiperEl = panel.querySelector("[data-best-sellers-swiper]");
      if (!swiperEl) return;

      const id = panel.getAttribute("data-best-sellers-panel");
      const progressEl = panel.querySelector("[data-best-sellers-progress]");
      const prevEl = panel.querySelector("[data-best-sellers-prev]");
      const nextEl = panel.querySelector("[data-best-sellers-next]");

      swipers[id] = new Swiper(swiperEl, {
        enabled: false,
        watchOverflow: true,
        grabCursor: true,
        breakpoints: {
          769: {
            enabled: true,
            slidesPerView: 2,
            spaceBetween: 18,
          },
          1025: {
            enabled: true,
            slidesPerView: 3,
            spaceBetween: 18,
          },
        },
        pagination: {
          el: progressEl,
          type: "progressbar",
        },
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl,
        },
        on: {
          init: function () {
            updateControls(this, panel);
          },
          resize: function () {
            updateControls(this, panel);
          },
          breakpoint: function () {
            updateControls(this, panel);
          },
        },
      });
    });

    initCardGalleries();

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        const target = tab.getAttribute("data-best-sellers-tab");

        tabs.forEach(function (item) {
          const isActive = item === tab;
          item.classList.toggle("is-active", isActive);
          item.setAttribute("aria-selected", isActive ? "true" : "false");
        });

        panels.forEach(function (panel) {
          const id = panel.getAttribute("data-best-sellers-panel");
          const isActive = id === target;
          panel.classList.toggle("is-active", isActive);
          panel.hidden = !isActive;

          if (isActive && swipers[target]) {
            swipers[target].update();
            initCardGalleries(panel);
          }
        });
      });
    });

    section.querySelectorAll("[data-best-sellers-add]").forEach(function (btn) {
      btn.addEventListener("click", async function () {
        const variantId = Number(btn.getAttribute("data-variant-id"));
        if (!variantId || btn.disabled) return;

        const originalHtml = btn.innerHTML;
        try {
          btn.disabled = true;
          btn.textContent = "Adding...";
          await addToCart(variantId, 1);
          document.dispatchEvent(
            new CustomEvent("cart:refresh", { detail: { openDrawer: true } })
          );
        } catch (error) {
          console.error("Best sellers add to cart error:", error);
        } finally {
          btn.disabled = false;
          btn.innerHTML = originalHtml;
        }
      });
    });
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll("[data-best-sellers]").forEach(initBestSellers);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) return;
    initAll(event.target);
  });
})();
